<template>
    <section :ref="selectID" :class="inputClass" class="ui-input ui-select">
        <div v-if="label" class="label">
            <div>
                <span :style="{'color' :labelColor}" v-html="label" />
                <span v-if="required" class="label-required">*</span>
            </div>
            <span v-if="tooltip" class="tooltip">
                <i :class="tooltipIcon" class="tooltip-icon">
                    <span class="tooltip-text">{{ tooltipText }}</span>
                </i>
            </span>
            <span v-else class="rigth-label">
                {{ rightLabel }}
            </span>
        </div>

        <div :ref="`${selectID}-select-box`" class="ui-select-box">
            <!-- <div v-if="multiple" :class="selectedClass" class="selected" :style="{'background-color': backgroundColor}" @click="toggle" >
                {{ total ? 'Selecionados: ' + total : placeholder }}
            </div>

            <div v-else :class="selectedClass" class="selected" :style="{'background-color': backgroundColor}" @click="toggle">
                {{ selecteds && selecteds[itemLabel] ? selecteds[itemLabel] : placeholder }}
            </div> -->

            <section v-if="search" class="search" :class="selectedClass" @click="toggle">
                <div class="search-box">
                    <input ref="search" v-model="s" :disabled="redirectRegisterCliente" type="text" placeholder="Buscar" />

                    <div class="icon">

                        <em v-if="!open" class="fal fa-search" />

                        <em v-if="open && !itemsFilter.length" class="fal fa-times" />
                    </div>
                </div>
            </section>

            <div v-if="open && !redirectRegisterCliente" v-position="$refs[`${selectID}-select-box`]" class="options">
                <section class="list">
                    <div class="list-control">
                        <div>
                            <span v-if="maxSelection" class="span-max-selection">
                                {{ selecteds ? selecteds.length : 0 }} de {{ maxSelection }}
                            </span>
                        </div>

                        <div>
                            <button
                                v-if="selecteds && $mx_hasValue(selecteds.id) && !multiple"
                                type="button"
                                class="btn-cancel"
                                @click="removeSelect">
                                Remover Seleção
                            </button>

                            <button
                                v-if="multiple && !maxSelection"
                                type="button"
                                class="btn-cancel"
                                @click="selectAll">
                                {{ btnSelectAllLabel }}
                            </button>
                        </div>
                    </div>

                    <div ref="scroller" class="items scroll-color" @scroll="scrollHandler">
                        <ul v-if="(ajaxSearch && itemsFilter && itemsFilter.length) || itemsFilter.length">
                            <template v-if="groupBy">
                                <template v-for="(item, id) in itemsFilter">
                                    <h4 :key="'title-' + id" v-html="item.name" />

                                    <template v-for="(i, key) in item.items">
                                        <li
                                            v-if="disableSelect && i[disableSelect] && i[disableSelect] === true"
                                            :key="`${item.name}-item-${key}`"
                                            class="active">
                                            <div class="data">
                                                <div v-if="cover" class="cover">
                                                    <img :src="i.cover" :alt="i.label" />
                                                </div>

                                                <div class="infos">
                                                    <div class="label">{{ i.label }}Olamundo</div>
                                                    <div v-if="i.text" class="text" v-html="i.text" />
                                                </div>
                                            </div>

                                            <div class="data-control" />
                                        </li>

                                        <li
                                            v-else
                                            :key="`${item.name}-item-enable-${key}`"
                                            :class="{ active: setActive(i) }"
                                            @click="select(i)">
                                            <div class="data">
                                                <div v-if="cover" class="cover">
                                                    <img :src="i.cover" :alt="i.label" />
                                                </div>

                                                <div class="infos">
                                                    <div class="label">
                                                        {{ i.label }}
                                                        <span v-if="i.required" style="color:red">*</span>
                                                    </div>

                                                    <div v-if="i.text" class="text" v-html="i.text" />
                                                </div>
                                            </div>

                                            <div class="data-control" />
                                        </li>
                                    </template>
                                </template>
                            </template>

                            <template v-else>
                                <li
                                    v-for="(item, key) in itemsFilter"
                                    :key="key"
                                    :class="{ active: setActive(item), 'li-card': cards }"
                                    @click="select(item)">
                                    <div class="data">
                                        <div v-if="cover" class="cover">
                                            <img :src="item.cover" :alt="item.label" />
                                        </div>

                                        <div :class="{'card-infos': cards}" class="infos">
                                            <span
                                                v-if="stageStatus"
                                                :title="item.stage"
                                                class="stage-status"
                                            >
                                                {{ item.stage }}
                                            </span>

                                            <p class="label">
                                                {{ item.label }}
                                                <span v-if="item.required" style="color:red">*</span>
                                            </p>

                                            <p class="label-cpf">
                                                {{ item.customer_cpf | documentBr }}
                                                <span v-if="item.required" style="color:red">*</span>
                                            </p>

                                            <span class="text" v-html="returnText(item.text)" />
                                        </div>
                                    </div>

                                    <div
                                        v-if="item.customer_email || item.customer_mobile"  
                                        class="data-email-phone"
                                        :class="{ active: setActive(item) }"
                                    >
                                        <span v-if="item.customer_email" class="email">{{ item.customer_email }}</span>

                                        <span v-if="item.customer_mobile" class="phone">{{formatPhoneNew(item.customer_country_code_mobile, item.customer_mobile)}}</span>
                                    </div>
                                </li>
                            </template>
                        </ul>

                        <div v-if="(ajaxSearch && itemsFilter && itemsFilter.length) || itemsFilter.length" class="button-add-client">
                            <ui-button
                                @click="callCreateDealModal"
                            >
                                <em class="fal fa-plus" />
                                Cadastrar Cliente
                            </ui-button>
                        </div>

                        <div v-if="itemsFilter && !itemsFilter.length && !ajaxSearch" class="no-items">
                            Nenhum cliente encontrado.
                            <ui-button
                                @click="callCreateDealModal"
                            >
                                <em class="fal fa-plus" />
                            </ui-button>
                        </div>

                        <div class="no-items" :class="{ 'clear-no-items': itemsFilter.length && itemsFilter.length > 0}">
                            <span v-if="!s || (s.length && s.length < 2)">Digite pelo menos 2 letras</span>
                            <div v-else-if="(!itemsFilter.length || itemsFilter.length == 0) && !load">
                                <span>
                                    Nenhum cliente encontrado.
                                </span>
                                <ui-button
                                    design="sm primary"
                                    @click="callCreateDealModal"
                                >
                                    <em class="fal fa-plus" />
                                </ui-button>
                            </div>
                            <span v-else-if="load"> Carregando... </span>
                        </div>
                    </div>
                </section>

                <section v-if="itemsFilter && itemsFilter.length && showFooter" class="control">
                    <button type="button" class="btn-cancel" @click="cancel(true)">Cancelar</button>
                    <button
                        v-if="multiple && showApplyButton"
                        type="button"
                        class="btn-apply"
                        @click="endSelections">
                        {{ applyButton }}
                    </button>
                </section>

                <section v-if="search" class="search search--bottom">
                    <div class="search-box">
                        <input ref="search" v-model="s" type="text" placeholder="Buscar" />

                        <div class="icon">
                            <em
                                v-if="addSelecteds && itemsFilter && !itemsFilter.length"
                                class="fal fa-plus"
                                @click="callCreateDealModal" />

                            <img v-else src="./search-light.svg" width="20" alt="Ícone de busca" />
                        </div>
                    </div>
                </section>
            </div>
        </div>
        <div v-if="setError" class="observation-message">
            {{ observation }}
        </div>
    </section>
</template>

<script>
	import { utilMixin, maskIntl } from '@/mixins'
	import { uiButton } from '@/components/ui/buttons'
    import { phoneMask, documentBr } from '@/filters'

	export default {
		name: 'ui-select-v3',

		components: { uiButton },

        filters: { phoneMask, documentBr },

		directives: {
			position: {
				inserted(el, binding) {
					const ref = binding.value

					const distance = ref.getBoundingClientRect()
					const body = document.body

					const elementHeight = el.clientHeight

					if (distance.top + elementHeight > body.clientHeight) {
						el.classList.add('options--open-up')
						el.classList.remove('options--open-down')
					} else {
						el.classList.remove('options--open-up')
						el.classList.add('options--open-down')
					}
				},
			},
		},

		mixins: [utilMixin, maskIntl],

		props: {
			/**
			 * Define o texto acima do input.
			 */
			label: {
				type: String,
				required: false,
				default: ''
			},
			/**
             * altera a cor do label
             */
            labelColor: {
                type: String,
                default: ''
            },
			/**
			 * Dados que serão mostrados no select
			 */
			data: {
				type: Array,
				required: false,
				default: () => [],
			},
			/**
			 * Property que será interpolada pela v-model.
			 * Obs: Não usar a property value, basta usar a v-model.
			 * Obs2: Caso queira passar valores pré definidos basta passar os valores para a v-model
			 * logo após carregar os valores da property data.
			 */
			value: {
				type: null,
				required: true,
			},
			/**
			 * Item Label
			 * Define o valor que será mostrado como label do select.
			 * Irá buscar nos objetos do data a chave do json com o nome passado.
			 */
			itemLabel: {
				type: String,
				required: false,
				default: 'label'
			},
			/**
			 * Text Items
			 * Define o texto mostrado no subtexto do item.
			 */
			textItems: {
				type: Array,
				required: false,
				default() {
					return []
				}
			},
			/**
			 * Cover.
			 * Define o valor que será mostrado na imagem do item.
			 * Caso não exista, a imagem será ignorada.
			 * Irá buscar nos objetos do data a chave do json com o nome passado.
			 */
			cover: {
				type: String,
				required: false,
				default: ''
			},
			/**
			 * Before Text Item
			 * Define o texto mostrado antes do sub texto do item
			 */
			beforeTextItem: {
				type: Array,
				required: false,
				default() {
					return []
				}
			},
			/**
			 * After Text Item
			 * Define o texto mostrado após o sub texto do item
			 */
			afterTextItem: {
				type: Array,
				required: false,
				default() {
					return []
				}
			},
			/**
			 * Multiple.
			 * Define se poderá selecionar mais de um único item.
			 */
			multiple: {
				type: Boolean,
				default: false,
			},
			/**
			 * Search
			 * Define se o input de buscar irá aparecer
			 */
			search: {
				type: Boolean,
				default: true,
			},
			/**
			 * Return value
			 * Define qual chave do objeto será retornada para a v-model
			 * Caso não seja passada irá retornar todo o objeto selecionado.
			 */
			returnValue: {
				type: String,
				default: 'object',
			},
			/**
			 * Utilize para alterar o tamanho do input
			 */
			size: {
				type: String,
				required: false,
				default: 'md',
			},
			/**
             * Controle de background-color do elemento
             */
			 backgroundColor: {
                type: String,
                required: false,
                default:'transparent'
            },
			/**
			 * Group By
			 * Define qual chave do objeto será usada para agrupar itens.
			 * Além de value e label, também é necessário ter um id.
			 */
			groupBy: {
				type: String,
				default: ''
			},
			/**
			 * Disable Select
			 * Define qual chave do objeto será usada para definir quais itens estarão desabilitadas
			 * para seleção, sendo assim obrigatórias.
			 */
			disableSelect: {
				type: String,
				default: ''
			},
			/**
			 * Add Selecteds
			 * Define se o botão de adicionar itens irá aparecer no local do icone de busca.
			 * Neste caso ele irá aparecer apenas caso a busca não retorne objetos.
			 * Caso seja adicionado irá adicionar um id baseado no length e uma label + value equivalentes.
			 *
			 * Não deve ser usada para objetos complexos. Apenas para objetos com id, label e value como chave.
			 */
			addSelecteds: {
				type: Boolean,
				required: false,
				default: false,
			},
			/**
			 * Disabled.
			 * Define se o componente irá estar ativo ou não.
			 * Caso seja true o objeto não irá aceitar os clicks.
			 */
			disabled: {
				type: Boolean,
				required: false,
				default: false,
			},
			/**
			 * define o input como required em html5 e aplica o operador '*' na label
			 */
			required: {
				type: Boolean,
				required: false,
				default: false,
			},
			/**
			 * Error
			 * Adiciona uma classe error ao componente. Deixando suas bordas avermelhadas
			 */
			error: {
				type: Boolean,
				required: false,
			},
			/**
			 * Define se existe algum limite de quantidade de seleções.
			 */
			maxSelection: {
				type: Number,
				required: false,
				default: null
			},
			/**
			 * Define se os valores de data ainda estão em load
			 */
			loading: {
				type: Boolean,
				required: false,
				default: false,
			},
			/**
			 *  Define a busca como sendo uma requisição http
			 */
			ajaxSearch: {
				type: Boolean,
				required: false,
				default: false,
			},
			/**
			 * Define o evento a ser chamado quando buscar
			 */
			searchEvent: {
				type: String,
				required: false,
				default: ''
			},
			/**
			 * Define se as opções (Footer) irá aparecer
			 */
			showFooter: {
				type: Boolean,
				required: false,
				default: true,
			},
			/**
			 * Define o placeholder
			 */
			placeholder: {
				type: String,
				required: false,
				default: 'Selecione',
			},
			/**
			 * Define o alinhamento das options
			 */
			align: {
				type: String,
				required: false,
				default: 'normal',
			},
			/**
			 * Define o texto do botão aplicar
			 */
			applyButton: {
				type: String,
				required: false,
				default: 'Aplicar',
			},
			/**
			 * Define o radius da borda
			 */
			design: {
				type: String,
				required: false,
				default: 'mgb-15 br-default',
			},
			/**
			 * Define o evento que vai ser emitido quando o seletor for aberto
			 */
			openEvent: {
				type: String,
				required: false,
				default: ''
			},
			/**
			 * Define o evento que vai ser escutado para limpar o uiSelectV2
			 */
			cancelEvent: {
				type: String,
				required: false,
				default: ''
			},
			stageStatus: {
				type: Boolean,
				default: false
			},
			cards: {
				type: Boolean,
				default: false
			},
			subtitle: {
				type: String,
				default: ''
			},
			tooltip: {
				type: Boolean,
			},
			tooltipIcon: {
				type: String,
				default: 'fal fa-question-circle'
			},
			tooltipText: {
				type: String,
				default: ''
			},
			/**
			 * Define se o botão de aplicar seleção será mostrado
			 */
			showApplyButton: {
				type: Boolean,
				default: true
			},
			/**
			 * ativa o label do lado direito da tela
			 */
			rightLabel: {
				type: String,
				default: ''
			},
			/**
			 * mostra uma informação abaixo do select
			 */
			 observation: {
				type: String,
				default: ''
			 },
			 isIframe: {
				type: Boolean,
				default: false
			}
		},

		data() {
			return {
				open: false,
				redirectRegisterCliente: false,
				id: this._uid,
				items: [],
				selecteds: [],
				s: '',
				btnSelectAllLabel: 'Selecionar todos',
				lastSearch: '',
				interval: null,
				setError: false,
				load: false,
				charge: true
			}
		},

		computed: {
			selectID() {
				return 'select-' + this.id
			},
			total() {
				return this.selecteds ? this.selecteds.length : 0
			},
			inputClass() {
				return [this.open ? 'open' : '', this.size, this.align, this.design]
			},
			selectedClass() {
				return [
					this.disabled ? 'disabled' : '',
					this.loading ? 'load disabled' : '',
					this.setError ? 'error' : '',
				]
			},
			/**
			 * Retorna os itens filtrados pela busca.
			 * Caso o ajax esteja ativo irá emitir o evento de busca, caso a busca seja diferente da anterior.
			 * Caso seja do tipo groupBy irá buscar elementos dentro dos grupos de objetos.
			 * Caso seja um componente normal, apenas busca dentro dos itens de forma convencional.
			 */
			itemsFilter() {
				if (this.ajaxSearch && this.items) return this.items

				let keys = []

				if (this.groupBy && this.items) {
					let items = []

					Object.keys(this.items).map((element) => {
						let t = []
						this.items[element].map((e) => {
							if (this.s && e.label) {
							// Alteração para pesquisa insensível a maiúsculas e minúsculas
							if (e.label.toLowerCase().includes(this.s.toLowerCase())) t.push(e)
							} else {
							t.push(e)
							}
						})

						if (t.length) {
							items.push({
							name: element,
							items: t,
							})
						}
					})

					return items
				} else {
					if (this.items && this.items.length) {
						keys = Object.keys(this.items[0])
					}
					return this.items.filter((i) => {
						let s = ''
						keys.map((e) => {
							if (
							e != 'id' &&
							e != 'ID' &&
							e != 'cover' &&
							e != 'avatar' &&
							e != 'photo' &&
							e != 'foto' &&
							e != 'image'
							) {
							s += i[e] + ' '
							}
						})
					// Alteração para pesquisa insensível a maiúsculas e minúsculas
					return s.toLowerCase().includes(this.s.toLowerCase())
					})
				}
			}
		},

		watch: {
			data(v) {
				if (!v) this.selecteds = this.multiple ? [] : null

				this.items = []
				this.prepareOptions()

				if (this.$mx_hasValue(this.selecteds) && !this.multiple) {
					const value = this.returnValue !== 'object'
						? this.selecteds[this.returnValue]
						: { ...this.selecteds }
					this.$emit('input', value)
				}
			},

			loading(value) {
				this.load = value
			},
			items() {
				this.open = true
			},
			s(value) {
				if(value == '') {
					this.selecteds = this.multiple ? [] : null
					this.$root.$emit(`select-v2-ajax-search-${this.searchEvent}`, {
						search: '',
						nextPage: false,
					}, true)
					return
				}

				if(!this.charge) {
					this.charge = true
					return
				}

				/**
				 * Verifica se o select está aberto, para evitar o bug que limpa a seleção em alguns
				 * selects, como o uiDealSelector, pois quando a string de busca é limpa ao fechar o
				 * select emite-se o evento de busca ajax, caso esta esteja ativa.
				 */
				this.load = value && value.length >= 2 ? true : false
				if (this.ajaxSearch && !this.redirectRegisterCliente) {
					clearInterval(this.interval)
					this.interval = setInterval(() => {
						clearInterval(this.interval)
						this.interval = null

						if ((value && value.length >= 2) && this.lastSearch !== value) {
							this.$root.$emit(`select-v2-ajax-search-${this.searchEvent}`, {
								search: value,
								nextPage: false,
							})

						} else {
							this.$emit('update:data', [])
						}
						this.lastSearch = value
					}, 1500)
				}
			},
			/**
			 * Observa a v-model
			 * Caso seja multiplo faz uma busca e retorna os objetos dentro de um array de objetos
			 * Caso seja multiplo com return value ativo retorna apenas os valores definidos dentro de um array
			 * Caso não seja multiplo faz uma busca ao objeto dentro dos itens filtrados e retorna o objeto selecionado
			 * Caso não seja multiplo e tenha return value ativo retorna apenas a chave do objeto selecionado
			 */
			value(v) {
				this.setSelectedValues(v)
			},
			open(val) {
				if (val && (this.openEvent && this.openEvent != '')) {
					this.$root.$emit(`select-v2-open-event-${this.openEvent}`)
				}

				if (!val && this.multiple && this.selecteds && this.selecteds.length > 0) {
					this.$emit('input', this.selecteds)
				}
			},
			multiple(value) {
				this.selecteds = value ? [] : null
			},
			error: {
                immediate: true, // Chama a função de callback imediatamente após o componente ser montado
                handler(newValue) {
                    this.setError = newValue
                },
            }
		},

		created() {
			if (this.cancelEvent && this.cancelEvent != '') {
				this.$root.$on('select-v2-cancel-event-' + this.cancelEvent, () => {
					this.cancel()
				})
			}
		},

		mounted() {
			this.$root.$on('set-input-search-select-v3', (s, redirectRegisterCliente) => {
				this.s = s
				this.redirectRegisterCliente = redirectRegisterCliente
			})

			this.prepareOptions()
			window.addEventListener("click", this.close )
		},

		beforeDestroy() {
			window.removeEventListener("click", this.close)
			this.$root.$off('set-input-search-select-v3')
			this.$root.$off('select-v2-cancel-event-' + this.cancelEvent)
		},

		methods: {
			stageStatusComputed(stage, status) {
				return stage ? status && status != '' ? `${ stage } <span> - ${ status }</span>` : `${ stage }` : ''
			},
			returnText(text) {
				let textTrim = text ? text.trim() : ''
				return text && textTrim != "" ? text : !this.cards ? '' : this.subtitle ? this.subtitle : ''
			},
			setSelectedValues(v) {
				if (!v || (Array.isArray(v) && v.length === 0)) {
					this.selecteds = this.multiple ? [] : null
					return
				}

				if (this.multiple) {
					let items = []
					if (this.returnValue !== 'object') {
						items = v
					} else {
						items = v.map((data) => {
							data.label = data[this.itemLabel]
							return data
						})
					}
					this.selecteds = items
					this.btnSelectAllLabel = this.maxSelection && this.selecteds.length === this.maxSelection
						? 'Remover todos'
						: 'Selecionar todos'

				} else {
					if (this.returnValue !== 'object') {
						if (this.groupBy && this.items) {
							Object.keys(this.items).forEach(element => {
								const result = this.items[element].find(e => e[this.returnValue] === v)
								if(result) this.selecteds = result
							})

						} else {
							const result = this.itemsFilter.find(e => e[this.returnValue] === v)
							if(result) this.selecteds = result
						}

					} else {
						if (!v[this.itemLabel]) {
							const selected = this.items.find(e => e.id === v.id)
							v = selected || null

						} else {
							v.label = v[this.itemLabel]
						}
						this.selecteds = v
					}
				}
			},

			/**
			 * Mostra ou esconde o select
			 */
			toggle() {
				this.open = !this.open
				this.setError = this.open ? false : this.error
				if (this.search && this.open) {
					setTimeout(() => {
						if (this.$refs.search) {
							this.$refs.search.focus()
						}
					}, 100)
				}
			},
			/**
			 * Esconde o select
			 */
			close(e) {
				if (!this.$refs[this.selectID].contains(e.target)) {
					this.setError = !this.selecteds || (this.selecteds.length && this.selecteds.length === 0) || this.selecteds === '' ? this.error : false
					this.open = false
				}
			},
			/**
			 * Limpa a busca e esconde o select
			 */
			cancel(event) {
				if (event) this.$emit('cancel')

				this.open = false
				this.s = ''
				this.items = []
				this.prepareOptions(false)
				// Emite o evento de cancelamento caso tenha sido utilizado o botão de cancelar seleção
			},
			/**
			 * Prepara o agrupamento baseado na string passada no groupby
			 * é necessário que a chave equivalente exista nos objetos
			 */
			separeGroups() {
				return this.data.reduce((a, o) => {
					let key = o[this.groupBy]
					if (!a[key]) {
						a[key] = []
					}
					o.label = o[this.itemLabel]
					a[key].push(o)
					return a
				}, {})
			},
			prepareItem(data, index) {
				let keys = this.textItems ? this.textItems : []
				let after = this.afterTextItem ? this.afterTextItem : []
				let before = this.beforeTextItem ? this.beforeTextItem : []

				let text

				if (keys) {
					let textItems = []

					keys.map((e, i) => {
						let afterText = after[i] ? after[i] : ''
						let beforeText = before[i] ? '<strong>' + before[i] + '</strong>' : ''

						if (keys.length <= 1) {
							text = beforeText + ' ' + data[e] + ' ' + afterText
							return
						}

						let textFull = beforeText + ' ' + data[e] + ' ' + afterText
						textItems.push(textFull)
					})

					if (textItems.length) {
						text = textItems.join(' - ')
					}
				}

				let item = {}
				let dataType = typeof this.data[0]

				if (dataType !== 'object') {
					item.id = index
					item.label = data
					return item
				}

				(item.id = data.id || index),
					(item.cover = data[this.cover]),
					(item.label = data[this.itemLabel]),
					(item.text = text),
					(item = { ...item, ...data })

				return item
			},
			/**
			 * Carrega as opções a serem mostradas no select
			 */
			prepareOptions(setSelected = true) {
				// Limpa as seleções das opções anteriores, caso existam
				this.selecteds = []

				if (this.groupBy) {
					let items = this.separeGroups()
					if(this.data) {
						for (const item of this.data) {
						if (this.disableSelect && item[this.disableSelect]) this.select(item)
						}
						this.items = items
					}
				} else {
					if(this.data) {
						for (const [index, item] of this.data.entries()) {
							if (this.disableSelect && item[this.disableSelect]) this.select(item)

							let option = this.prepareItem(item, index)
							this.items.push(option)
						}
					}
				}

				/**
				 * Caso o processo de carregamento dos itens já tenha selecionado certas opções por meio
				 * das opções desativadas, emite o evento para alterar a prop value
				 */
				if (this.$mx_hasValue(this.selecteds)) this.$emit('input', this.selecteds)
				/**
				 * Mantém o uso da função setSelectedValues, pois pode ser que os itens selecionados
				 * durante o carregamento das opções são iguais ao valor default da prop value,
				 * o que não acarretaria a chamada do watch da prop value
				 */
				if (setSelected) this.setSelectedValues(this.value)
			},
			select(item, emit = true) {
				if (this.multiple) {
					let index = this.selecteds.findIndex((x) => {
						if (this.returnValue !== 'object') return x == item[this.returnValue]

						return x.id == item.id
					})

					if (index < 0) {
						if (this.selecteds && this.maxSelection && this.maxSelection === this.selecteds.length) {
							if (emit) this.$emit('input', this.selecteds)

							return this.toggle()
						}

						const value = this.returnValue !== 'object' ? item[this.returnValue] : item
						this.selecteds.push(value)

					} else {
						this.selecteds.splice(index, 1)
						this.$emit('input', this.selecteds)
					}

					this.btnSelectAllLabel = this.selecteds.length === this.items.length
						? 'Remover todos'
						: 'Selecionar todos'

					// Caso o botão de Aplicar não está sendo mostrado, emite o evento de input
					if (!this.showApplyButton && emit) this.$emit('input', this.selecteds)

				} else {
					if (!this.selecteds || item.id !== this.selecteds.id) {
						this.selecteds = { ...item }
						this.charge = false
						this.s = item.customer_name;

					} else {
						this.selecteds = null
					}

					if (emit) {
						if (this.selecteds && this.returnValue !== 'object') {
							this.$emit('input', this.selecteds[this.returnValue])

						} else {
							this.$emit('input', this.selecteds)
						}
					}
					this.toggle()
				}
			},
			selectAll() {
                let total = this.items.length
				let selecteds = this.selecteds.length
				this.selecteds = []

				if (typeof this.items === 'object' && !Array.isArray(this.items)) {
					total = 0
                    Object.keys(this.items).forEach((e) => total += this.items[e].length)
				}

                if (selecteds === total || (this.maxSelection && selecteds === this.maxSelection)) {
                    if (this.disableSelect) {
                        this.selecteds = this.data.filter((e) => {
							if (this.disableSelect && e[this.disableSelect]) return e
						})
                    }

                    this.btnSelectAllLabel = 'Selecionar todos'
                    this.$emit('input', this.selecteds)
                    return
                }

                if (this.groupBy) {
                    Object.keys(this.items).forEach((element) => {
                        this.items[element].forEach((e) => {
                            this.select(e, false)
                        })
                    })
                } else {
                    if (this.disableSelect) {
                        this.itemsFilter.forEach((e) => {
                            e.items.forEach((i) => {
                                this.select(i, false)
                            })
                        })
                    } else {
                        this.itemsFilter.forEach((e) => {
                            this.select(e, false)
                        })
                    }
                }

				this.btnSelectAllLabel = 'Remover todos'
                this.$emit('input', this.selecteds)
			},
			removeSelect() {
				if (this.disableSelect) {
					let selecteds = []
					this.selecteds.forEach((e) => {
						if (e[this.disableSelect]) {
							selecteds.push(e)
						}
					})

					this.selecteds = selecteds
				} else {
					this.selecteds = null
				}

				this.$emit('input', this.selecteds)
				this.$emit('remove-select')
				this.cancel()
			},
			setActive(item) {
				if (this.multiple) {
					let index = this.selecteds.findIndex((x) => {
						if (this.returnValue !== 'object') {
							return x == item[this.returnValue]
						} else {
							return x.id == item.id
						}
					})
					if (index >= 0) return true

				} else {
					return this.selecteds && item.id == this.selecteds.id ? true : false
				}
			},

			scrollHandler(event) {
				const bottom =
					event.target.scrollHeight - event.target.scrollTop === event.target.clientHeight

				if (bottom) {
					clearInterval(this.interval)
					this.interval = null
					this.$root.$emit(`select-v2-ajax-search-${this.searchEvent}`, {
						search: this.s,
						nextPage: true,
					})
				}
			},

			endSelections() {
				this.toggle()
				this.$emit('input', this.selecteds)
			},

			callCreateDealModal() {
				if (this.isIframe) this.$root.$emit('modal-open-global--create-deal-modal', null, true, true)
				else this.$root.$emit('modal-open-create-deal-modal', null, true, false)
				this.$root.$emit('modal-close-global--request-reserve');
			},
		},
	}
</script>

<style lang="stylus" scoped>
	@import 'styles.styl'
</style>